import ImportCsvFileDropzone from "./dropzone";
import ImportCsvFileColumnMapper from "./column-mapper";

/**
 * @typedef {{
 *    name: string,
 *    title: string,
 *    optional?: boolean,
 *    generator: function(number): any,
 *    format?: (any) => any,
 *    showProductInformationPopover?: boolean,
 *    }} ImportCsvFileRequiredField
 */

export const ImportCsvFileSteps = {
    dropzone: 'dropzone',
    columnMapper: 'columnMapper',
}

const ImportCsvFile = ({
                           fields,
                           dropzoneNotes,
                           step,
                           parsedColumns,
                           parsedRows,
                           onDropzoneParsed,
                           onColumnMapperParsed,
                           sampleFileTitle,
                           sampleFileRowCount,
                           formId,
                           columnMapperInitialValues,
                           offsetStartingHeight,
                           offsetEndingHeight,
                           getScrollParent,
                       }) => {

    return (
        <>
            {
                step === ImportCsvFileSteps.dropzone && (
                    <ImportCsvFileDropzone
                        onParsed={onDropzoneParsed}
                        fields={fields}
                        notes={dropzoneNotes}
                        sampleFileTitle={sampleFileTitle}
                        sampleFileRowCount={sampleFileRowCount}
                    />
                )
            }
            {
                step === ImportCsvFileSteps.columnMapper && (
                    <ImportCsvFileColumnMapper
                        formId={formId}
                        rows={parsedRows}
                        columns={parsedColumns}
                        fields={fields}
                        onParse={onColumnMapperParsed}
                        initialValues={columnMapperInitialValues}
                        offsetStartingHeight={offsetStartingHeight}
                        offsetEndingHeight={offsetEndingHeight}
                        getScrollParent={getScrollParent}
                    />
                )
            }
        </>
    );
}

export default ImportCsvFile;